module.exports = __webpack_public_path__ + "img/GreekTechSpearmanS_ua.fab4aa86.webp";